<div class="row">
    <div class="col-md-12">
        <mat-chip-list aria-label="Fish selection">
            <mat-chip *ngFor="let data of allDatas">{{data}}</mat-chip>
        </mat-chip-list>
    </div>
</div>